import type { IconProps } from '@magicschool/spellbook/components/Icon';
import { Icon } from '@magicschool/spellbook/components/Icon';
import type { LabelProps } from '@magicschool/spellbook/components/Label';
import { Label } from '@magicschool/spellbook/components/Label';
import { Slot } from '@magicschool/spellbook/components/Slot';
import { cn } from '@magicschool/spellbook/lib/utils';

const addOnSlotClassNames = ['font-normal', 'text-default-text-soft', 'shrink-0'];

export const LeadingAddOnSlot = Slot<LabelProps>({
  displayName: 'TextInput.LeadingAddOn',
  renderDefault: ({ children, className, ...props }) => {
    return (
      <Label data-spellbook-name="text-input-leading-add-on" className={cn(addOnSlotClassNames, className)} {...props}>
        {children}
      </Label>
    );
  },
});

export const LeadingAdornmentSlot = Slot<IconProps>({
  displayName: 'TextInput.LeadingAdornment',
  renderDefault: ({ name = 'square-dashed', className, size: _, color = 'default', ...props }) => {
    return (
      <Icon
        data-spellbook-name="text-input-leading-adornment"
        name={name}
        size="sm"
        color={color}
        className={cn('m-1', className)}
        {...props}
      />
    );
  },
});

export const TrailingAddOnSlot = Slot<LabelProps>({
  displayName: 'TextInput.TrailingAddOn',
  renderDefault: ({ children, className, ...props }) => {
    return (
      <Label data-spellbook-name="text-input-trailing-add-on" className={cn(addOnSlotClassNames, className)} {...props}>
        {children}
      </Label>
    );
  },
});

export const TrailingAdornmentSlot = Slot<IconProps>({
  displayName: 'TextInput.TrailingAdornment',
  renderDefault: ({ name = 'square-dashed', className, size: _, color = 'default', ...props }) => {
    return (
      <Icon
        data-spellbook-name="text-input-trailing-adornment"
        name={name}
        size="sm"
        color={color}
        className={cn('m-1', className)}
        {...props}
      />
    );
  },
});
